module.exports = __webpack_public_path__ + "static/media/ic-box.f8f68052.svg";